import { Fragment, useEffect, useState } from "react";
import { Search, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { adminApi, fmtErr, fmtDate } from "../api";
import { inputCls } from "../components";

const Enquiries = () => {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    adminApi.get("/enquiries").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  const filtered = (items || []).filter((e) =>
    `${e.name} ${e.company} ${e.email} ${e.interest}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="admin-enquiries-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Enquiries</h1>
          <p className="mt-1 text-sm text-slate-500">Every website enquiry — also emailed to sales@grengg.com.</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input className={`${inputCls} pl-9`} placeholder="Search enquiries…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="enquiries-search-input" />
        </div>
      </div>

      <div className="mt-6 bg-white border border-slate-200 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="border-b border-slate-200 text-left">
              {["", "Date", "Name", "Company", "Contact", "Interest"].map((h) => (
                <th key={h} className="px-5 py-3 text-[10px] font-bold uppercase tracking-widest text-slate-400">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items === null ? (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-400">Loading…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-400">No enquiries found.</td></tr>
            ) : (
              filtered.map((e) => (
                <Fragment key={e.id}>
                  <tr className="border-b border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => setOpenId(openId === e.id ? null : e.id)} data-testid={`enquiry-row-${e.id}`}>
                    <td className="px-5 py-3"><ChevronDown size={14} className={`text-slate-400 transition-transform ${openId === e.id ? "rotate-180" : ""}`} /></td>
                    <td className="px-5 py-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(e.created_at)}</td>
                    <td className="px-5 py-3 font-semibold text-slate-900">{e.name}</td>
                    <td className="px-5 py-3 text-slate-600">{e.company || "—"}</td>
                    <td className="px-5 py-3 text-xs text-slate-600">
                      <a href={`mailto:${e.email}`} className="text-[#C5221F] hover:underline" onClick={(ev) => ev.stopPropagation()}>{e.email}</a>
                      {e.phone && <><br />{e.phone}</>}
                    </td>
                    <td className="px-5 py-3"><span className="text-[10px] font-bold uppercase tracking-widest bg-slate-100 text-slate-600 px-2 py-1 rounded-sm">{e.interest}</span></td>
                  </tr>
                  {openId === e.id && (
                    <tr className="border-b border-slate-100 bg-slate-50">
                      <td colSpan={6} className="px-12 py-4 text-sm text-slate-700 whitespace-pre-line" data-testid={`enquiry-message-${e.id}`}>{e.message}</td>
                    </tr>
                  )}
                </Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Enquiries;
